import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

const COLOR_ITEMS = [
  { key: 'tefilotColor', label: 'זמני יום חול', defaultColor: '#0369a1' },
  { key: 'moadColor',    label: 'זמני מועד',    defaultColor: '#b45309' },
  { key: 'shabbatColor', label: 'זמני שבת',     defaultColor: '#7c3aed' },
];

/**
 * ZmanimDesignStep — צבעי מקורות תפילה לציר הזמן
 * Props: { formData, onChange }
 */
const ZmanimDesignStep = ({ formData, onChange }) => {
  return (
    <Stack spacing={3} dir="rtl">
      <Box>
        <Typography sx={{ fontWeight: 600, color: '#475569', mb: 1.5, fontSize: '0.875rem' }}>
          צבעי מקורות תפילה
        </Typography>
        <Typography sx={{ fontSize: '0.72rem', color: '#9ca3af', mb: 2 }}>
          הצבעים שבהם יסומנו זמני התפילות על ציר הזמן — לפי מקור
        </Typography>
        <Stack spacing={1.5}>
          {COLOR_ITEMS.map(({ key, label, defaultColor }) => {
            const value = formData[key] || defaultColor;
            return (
              <Stack key={key} direction="row" alignItems="center" spacing={2}>
                <Box
                  component="input"
                  type="color"
                  value={value}
                  onChange={(e) => onChange({ [key]: e.target.value })}
                  sx={{
                    width: 36, height: 28, borderRadius: 1,
                    border: '2px solid #e2e8f0', cursor: 'pointer',
                  }}
                />
                <Typography sx={{ fontSize: '0.875rem', color: '#475569' }}>{label}</Typography>
                <Typography sx={{ fontSize: '0.75rem', color: '#94a3b8', fontFamily: 'monospace' }}>{value}</Typography>
                {value !== defaultColor && (
                  <Typography
                    onClick={() => onChange({ [key]: defaultColor })}
                    sx={{
                      fontSize: '0.72rem', color: '#9ca3af', cursor: 'pointer',
                      textDecoration: 'underline', '&:hover': { color: '#374151' },
                    }}
                  >
                    איפוס
                  </Typography>
                )}
              </Stack>
            );
          })}
        </Stack>
      </Box>
    </Stack>
  );
};

export default ZmanimDesignStep;
